import { RequireOnly } from '@pelicargo/types';
import { FreightService, Request } from '@prisma/client';

import { INLAND_FREIGHT_SERVICES } from '../../constants';

export const requiresAirFreight = (request: RequireOnly<Request, 'freight_services'>) => {
  if (!request?.freight_services?.length) return false;
  return request?.freight_services?.some((service) => service === FreightService.AFR);
};

export const requiresInland = (request: RequireOnly<Request, 'freight_services'>) => {
  if (!request?.freight_services?.length) return false;
  return request?.freight_services?.some((service) => INLAND_FREIGHT_SERVICES.includes(service));
};

export const isAfrOnly = (request: RequireOnly<Request, 'freight_services'>) => {
  const needsAfr = requiresAirFreight(request);
  const needsInland = requiresInland(request);

  return needsAfr && !needsInland;
};
